import { Controller } from "@hotwired/stimulus"
import { createPopper } from '@popperjs/core'
import { leave, enter } from '@/el-transition'

export default class extends Controller {
    static targets = [
        'select',
        'content',
        'options',
        'dropdown',
    ]

    connect() {
        this.createFakeElement()
        this.optionsElements()
        this.updatePlaceholder()
        this.updateWidth()

        this.popper = createPopper(this.fakeElement, this.dropdownTarget, {
            placement: 'bottom',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 8],
                    },
                },
            ],
        })

        this.selectTarget.style.display = 'none'
    }

    disconnect() {
        this.popper.destroy()
    }

    updateWidth() {
        this.contentTarget.style.width = `${this.fakeElement.clientWidth}px`
    }

    leave() {
        leave(this.contentTarget, 'dropdown')
    }

    show() {
        if (this.contentTarget.classList.contains('hidden')) {
            enter(this.contentTarget, 'dropdown')
        }

        this.updateWidth()
        this.popper.update()
    }

    createFakeElement() {
        const element = document.createElement('div')

        element.classList = this.selectTarget.classList

        element.addEventListener("click", this.show.bind(this))

        this.element.appendChild(element)

        this.fakeElement = element
    }

    select({ params: { index } }) {
        const old = this.selectTarget.selectedIndex

        this.optionsTarget.childNodes[old].classList.replace('text-neon-red', 'text-50-shades-of-grey')
        this.optionsTarget.childNodes[index].classList.replace('text-50-shades-of-grey', 'text-neon-red')

        this.selectTarget.selectedIndex = index

        this.updatePlaceholder()

        this.selectTarget.dispatchEvent(new Event('change'))
    }

    updatePlaceholder() {
        const index = this.selectTarget.selectedIndex
        this.fakeElement.textContent = this.selectTarget.options[index].textContent
    }

    hide(event) {
        // @ts-ignore
        if (!this.element.contains(event.target) && !this.contentTarget.classList.contains('hidden')) {
            this.leave()
        }
    }

    optionsElements() {
        [...this.selectTarget.options].forEach((option, index) => {
            const button = document.createElement('button')
            button.type = 'button'

            button.classList.add(
                'block',
                'text-left',
                'text-base',
                'font-roboto',
                'transition-colors',
                option.selected ? 'text-neon-red' : 'text-50-shades-of-grey',
                'hover:text-neon-red',
            )

            button.setAttribute(`data-action`, `${this.identifier}#select ${this.identifier}#leave`)
            button.setAttribute(`data-${this.identifier}-index-param`, index)
            button.textContent = option.textContent
            this.optionsTarget.appendChild(button)
        })
    }
}
